import { Avatar, Dropdown, Layout, Menu } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { UserOutlined } from '@ant-design/icons';
import logo from '../assets/images/logo.png';
import { useAuth } from '../auth/AuthContext';
import { AUTH_ENABLED } from '../auth/authConfig';
import './Sidebar.css';

const { Sider } = Layout;

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const userMenuItems = AUTH_ENABLED
    ? [
      {
        key: 'logout',
        label: '退出登录',
      },
    ]
    : [
      {
        key: 'bypass',
        label: '免登录模式',
      },
    ];

  // 将菜单文字按每行两个字拆分显示
  const formatLabel = (text) => {
    const chars = text.split('');
    const lines = [];

    for (let i = 0; i < chars.length; i += 2) {
      lines.push(chars.slice(i, i + 2).join(''));
    }

    return (
      <span>
        {lines.map((line, index) => (
          <span key={index}>
            {line}
            {index !== lines.length - 1 && <br />}
          </span>
        ))}
      </span>
    );
  };

  const menuItems = [
    {
      key: '/produce',
      label: formatLabel('内容生产'),
    },
    {
      key: '/content',
      label: formatLabel('内容管理'),
    },
    {
      key: '/timedPublish',
      label: formatLabel('任务管理'),
    },
    {
      key: '/users',
      label: formatLabel('账号管理'),
    },
    {
      key: '/agents',
      label: (
        <span>
          Agent
          <br />
          管理
        </span>
      ),
    },
    {
      key: '/statistics',
      label: formatLabel('数据统计'),
    },
  ];

  const handleMenuClick = ({ key }) => {
    navigate(key);
  };

  const handleUserMenuClick = async ({ key }) => {
    if (!AUTH_ENABLED) return;
    if (key === 'logout') {
      await logout();
      navigate(`/login?return_to=${encodeURIComponent(location.pathname + (location.search || ''))}`);
      return;
    }
  };

  return (
    <Sider
      width={75} // 缩窄侧边栏，给内容区更多空间
      style={{
        overflow: 'hidden',
        height: '100vh',
        background: '#fff',
      }}
      theme="light"
    >
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div
          style={{
            height: 56,
            margin: '5px 8px 4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flex: '0 0 auto',
          }}
        >
          <img src={logo} alt="品牌Logo" style={{ height: 40, width: 'auto' }} />
          {/* <span style={{ color: '#fff', fontSize: 18, fontWeight: 600 }}>
            自动化运营平台
          </span> */}
        </div>
        <div style={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
          <Menu
            theme="light"
            mode="inline"
            selectedKeys={[location.pathname]}
            items={menuItems}
            onClick={handleMenuClick}
            className="custom-sidebar-menu"
          />
        </div>

        <div style={{ padding: 12, display: 'flex', justifyContent: 'center', flex: '0 0 auto' }}>
          <Dropdown menu={{ items: userMenuItems, onClick: handleUserMenuClick }} placement="topRight">
            <Avatar
              src={user?.avatar}
              icon={!user?.avatar ? <UserOutlined /> : undefined}
              style={{ cursor: 'pointer' }}
            />
          </Dropdown>
        </div>
      </div>
    </Sider>
  );
};

export default Sidebar;

